export const colors = {
    primary: "#5B2C06",
    secondary: "#000000",
    tertiary: "#000000",
    background: "#ffffff",
    backgroundText: "#ffffff",

    Background: {
        Block: {
            default: "#FAFAFA",
            dark: "#EBEBEB",
            darker: "#E1E1E1",
            highlight: "#FFFFFF",
        },
        Page: {
            default: "#F9F0F0",
        },
        Section: {
            default: "#FFFFFF",
            transparent: "rgba(220,220,220,0.87)",
        },
        Tab: {
            default: "#FFFFFF",
            dark: "#E0E0E0",
            darker: "#D6D6D6",
        },
        Button: {
            default: "#F5F5F5",
            dark: "#EBEBEB",
            highlight: "#F9F0F0",
            highlightDark: "#FAE6E6",
        },
        Tile: {
            highlight: "#E54C65",
        },
        Overlay: {
            default: "rgba(51, 51, 51, 0.5)",
            text: "#FFFFFF",
        },
        Input: {
            disabled: "#F5F5F5",
        },
    },
    Highlight: {
        default: "#E54C65",
        dark: "#963246",
        subtle: "rgba(229, 76, 101, 0.2)",
        medium: "rgba(229, 76, 101, 0.4)",
    },
    Notice: {
        background: "#F9F0F0",
        text: "#963246",
        border: "rgba(229, 76, 101, 0.2)",
    },
    Line: {
        default: "#E8E8E8",
        divider: "#EDD1DC",
        block: "#D6D6D6",
        dark: "#D6D6D6",
        darker: "#bebebeff",
        subtle: "rgba(194, 194, 194, 0.2)",
    },
    Text: {
        bright: "#FFFFFF",
        disable: "#AAAAAA",
        placeholder: "#AAAAAA",
        lighter: "#888888",
        light: "#555555",
        default: "#333333",
        dark: "#000000",
        onHighlight: {
            default: "#FFFFFF",
            muted: "rgba(255, 255, 255, 0.5)",
        },
    },
    TimeTable: {
        title: "#000000",
        detail: "#888888",
    },
    Tile: {
        TimeTable: {
            default: {
                red: {
                    1: "#F2CECE",
                    2: "#F4B3AE",
                },
                orange: {
                    1: "#F2BCA0",
                    2: "#F0D3AB",
                },
                yellow: {
                    1: "#F1E1A9",
                    2: "#F4F2B3",
                },
                green: {
                    1: "#DBF4BE",
                    2: "#BEEDD7",
                    3: "#B7D2DE",
                },
                blue: {
                    1: "#C9DAF4",
                    2: "#B4D3ED",
                },
                purple: {
                    1: "#B9C5ED",
                    2: "#D8C1F0",
                },
                pink: {
                    1: "#EBCAEF",
                    2: "#F4BADB",
                },
            },
        },
    },

    gradient: {
        blue: "linear-gradient(135deg, #E0F7FA 0%, #B2EBF2 50%, #80DEEA 100%)",
        purple: "linear-gradient(135deg, #E1BEE7 0%, #CE93D8 50%, #BA68C8 100%)",
        peach: "linear-gradient(135deg, #FFE0B2 0%, #FFCC80 50%, #FFB74D 100%)",
        mint: "linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 50%, #A5D6A7 100%)",
        sunset: "linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 50%, #EF9A9A 100%)",
    },
}
